<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>库存统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="仓库">
                    <el-select v-model="listQuery.houseIdList" clearable placeholder="请选择仓库" filterable multiple>
                        <el-option v-for="(item,index) in houseList" :key="index" :label="item.houseName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="商品SKU">
                    <el-input v-model="listQuery.skuCode" placeholder="请输入商品SKU" clearable></el-input>
                </el-form-item>

                <el-form-item label="商品名称">
                    <el-input v-model="listQuery.skuName" placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column   label="ID" type="index" width="50px" fixed="left"></el-table-column> 
                <el-table-column prop="skuCode" label="商品SKU"></el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>

                <el-table-column prop="allStockNumber" label="总库存数"></el-table-column>
                <el-table-column prop="allStockInNumber" label="总入库数"></el-table-column>
                <el-table-column prop="stockOutNumber" label="总出库数"></el-table-column> 
                 <el-table-column prop label="操作" fixed="right" width="180px" align="center">
                    <template slot-scope="scope"> 
                        <el-button type="text" @click="goStockLog(scope.row)" size="mini">出入库记录</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                skuCode: "",
                skuName: "",
                cityId: "",
                houseIdList: [],
            },
            cityList: [],
            houseList: [],
            tempHouseList: [],
            stockSubInfoList: [],
            showSubInfo: false,
        };
    },
    created() {
        this.getAllCity();
        this.getAllHouse();
        this.querySearch();
    },
    methods: {
         goStockLog(row) {
            this.$router.push({
                path: "/warehouseCenter/warehouseManage/stocklogList",
                query: {
                    skuCode: row.skuCode, 
                },
              
            });
        },
        cityChange(cityId) {
            this.listQuery.houseIds = [];
            let temparr = [];
            this.tempHouseList.filter((item) => {
                if (item.cityId == cityId) {
                    temparr.push(item);
                }
            });
            this.houseList = temparr;
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.houseIds = this.listQuery.houseIdList.join(",");
            wmsApi.$axiosWmsHouseStockgetStockReport(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllHouse() {
            //仓库下拉框
            wmsApi
                .$axiosgetAllHouse({ sysUserId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.houseList = res.data.data;
                        this.tempHouseList = res.data.data;
                    }
                });
        },
    },
    beforeCreate() {
        vm = this;
    },
    filters: {
        typeFilter(value) {
            const rs = vm.typeList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>